import { defineComponent as p, computed as a, createElementBlock as i, openBlock as s, normalizeStyle as f, normalizeClass as u, renderSlot as m, createCommentVNode as h, Fragment as c, createElementVNode as o, renderList as $, toDisplayString as g } from "vue";
import { _ as y } from "./_plugin-vue_export-helper-CHgC5LLL.js";
const x = p({
  inheritAttrs: !1,
  props: {
    validation: Object,
    errors: { type: Array, default: () => [] },
    /**
     * only include error from matched rules.
     * regexp execute on rule.$uid = <property path>-<rule key>
     * ex: "a.b.0.c-required"
     */
    validationIncludeRule: Array,
    validationSilentError: Boolean,
    hideErrors: Boolean,
    focused: Boolean,
    position: {
      type: String,
      default: "tr"
    }
  },
  setup(t) {
    const r = a(() => [
      ...t.validation ? t.validationSilentError ? t.validation.$silentErrors : t.validation.$errors : [],
      ...t.errors.map((e) => ({ $message: e, $uid: "" }))
    ]), n = a(
      () => {
        var e;
        return (e = t.validationIncludeRule) != null && e.length ? r.value.filter((l) => t.validationIncludeRule.some((v) => v.test(l.$uid))) : r.value;
      }
    );
    return {
      err: n,
      id: a(() => {
        var e, l;
        return (e = t.validation) != null && e.$path ? `v-${(l = t.validation) == null ? void 0 : l.$path}` : void 0;
      }),
      haveError: a(() => {
        var e;
        return !t.hideErrors && !!((e = n.value) != null && e.length);
      })
    };
  }
}), E = ["id"], w = { class: "tt-absolute tt-z-20 tt--top-2 tt--right-2 tt-pointer-events-none" }, B = { class: "tt-border tt-border-gray-300 tt-bg-white tt-text-xs tt-rounded-lg tt-py-0.5 tt-px-2 tt-right-0 tt-bottom-full" }, S = ["id"];
function b(t, r, n, e, l, v) {
  return s(), i("span", {
    class: u(["tt-relative", t.$attrs.class, t.haveError && "tx-error tx-has-tooltip"]),
    style: f(t.$attrs.style),
    id: t.id
  }, [
    m(t.$slots, "default"),
    t.haveError ? (s(), i(c, { key: 0 }, [
      o("div", w, [
        (s(), i("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 512 512",
          fill: "currentColor",
          class: u([t.focused ? "tt-text-red-500" : "tt-text-red-300", "tt-h-4 tt-w-4"])
        }, r[0] || (r[0] = [
          o("rect", {
            style: { fill: "#ffffff" },
            width: "135",
            height: "300",
            x: "190",
            y: "115"
          }, null, -1),
          o("path", { d: "M504 256c0 136.997-111.043 248-248 248S8 392.997 8 256C8 119.083 119.043 8 256 8s248 111.083 248 248zm-248 50c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418 136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884 0-12.356 5.78-11.981 12.654z" }, null, -1)
        ]), 2))
      ]),
      o("div", {
        class: u(["tx-tooltip", `tx-tooltip-${t.$props.position}`])
      }, [
        o("div", B, [
          (s(!0), i(c, null, $(t.err, (d) => (s(), i("p", {
            class: "tt-text-sm tt-text-red-600 tt-align-top",
            key: d.$uid,
            id: d.$uid
          }, g(d.$message), 9, S))), 128))
        ]),
        r[1] || (r[1] = o("svg", {
          x: "0px",
          y: "0px",
          viewBox: "0 0 255 255",
          "xml:space": "preserve"
        }, [
          o("polygon", { points: "0,0 127.5,127.5 255,0" })
        ], -1))
      ], 2)
    ], 64)) : h("", !0)
  ], 14, E);
}
const k = /* @__PURE__ */ y(x, [["render", b]]);
export {
  k as default
};
//# sourceMappingURL=ErrorTooltip-gIdejoEn.js.map
